import React, { Component } from 'react';
import { connect } from 'react-redux';
import { WithStyles, withStyles } from '@mui/styles';
import { withNavigation, withTranslate } from '../../core/TenantProvider';
import { ReactComponent as FlashOffIcon } from './assets/icon-flash.svg';
import MaintenanceContainerStyles from './styles/MaintenanceContainer.style';

interface MaintenanceContainerProps extends WithStyles<typeof MaintenanceContainerStyles> {
  translate: Function,
  navigate: any,
  location: any
}

class MaintenanceContainer extends Component<MaintenanceContainerProps, {}, {}> {

  render() {
    const {
      classes,
      translate
    } = this.props;

    return (
      <div className={classes.maintenanceContainer}>
        <div className={classes.bodyWrapper}>
          <div className={classes.bodyContent}>
            <h4>
              {translate('maintenance.view.title')}
            </h4>
            <p>
              {translate('maintenance.view.description')}
            </p>
            <div className={classes.iconWrapper}>
              <FlashOffIcon />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default (
  withNavigation(
    withTranslate(
      withStyles(MaintenanceContainerStyles)(
        connect(null, null)(MaintenanceContainer)
      )
    )
  )
);

